import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Bus, Menu, X, MapPin, Ticket, HelpCircle, Newspaper, Settings, Award } from 'lucide-react';
import logo from '../../assets/logo.png';
import './Header.css';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navItems = [
    { path: '/', label: 'Acasă', icon: Bus },
    { path: '/rute', label: 'Rute & Curse', icon: MapPin },
    { path: '/bilete', label: 'Bilete', icon: Ticket },
    // { path: '/flota', label: 'Flotă', icon: Bus },
    // { path: '/tarife', label: 'Tarife', icon: Settings },
    { path: '/suport', label: 'Suport', icon: HelpCircle },
    { path: '/blog', label: 'Noutăți', icon: Newspaper },
    { path: '/fonduri-europene', label: 'Fonduri UE', icon: Award },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <header className={`header ${isScrolled ? 'header-scrolled' : ''}`}>
      <div className="container">
        <div className="header-content">
          {/* Logo */}
          <Link to="/" className="logo">
            <img src={logo} alt="Multipower Tour Logo" className="logo-image" />
            
          </Link>

          {/* Desktop Navigation */}
          <nav className="nav-desktop">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`nav-link ${isActive(item.path) ? 'nav-link-active' : ''}`}
              >
                <item.icon size={18} />
                <span>{item.label}</span>
              </Link>
            ))}
          </nav>

           
        </div>

        {/* Mobile Navigation */}
        {isMobileMenuOpen && (
          <nav className="nav-mobile">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`nav-mobile-link ${isActive(item.path) ? 'nav-mobile-link-active' : ''}`}
                onClick={() => setIsMobileMenuOpen(false)}
              >
                <item.icon size={20} />
                <span>{item.label}</span>
              </Link>
            ))}
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;
